import { CLEAR_SITE_DATA } from '../application';
import {
  ADD_FILES,
  REMOVE_UPLOAD,
  INIT_UPLOAD,
  UPLOAD_STARTED,
  UPLOAD_PROGRESS,
  UPLOAD_COMPLETED,
  UPLOAD_FAILED,
  ADDED,
  INITIALIZED,
  UPLOADING,
  UPLOADED,
  FAILED,
} from './actions';

const initialState = {
  objects: {},
  ids: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case ADD_FILES: {
      const { files, siteId, modelId } = action;

      const [newObjects, newIds] = files.reduce(
        ([objects, ids], file) => {
          const id = Math.random().toString(36);

          objects[id] = {
            id,
            file,
            isZip: file.name.split('.').pop().toLowerCase() === 'zip',
            siteId,
            modelId,
            modelName: file.name,
            status: ADDED,
          };
          ids.push(id);
          return [objects, ids];
        },
        [{}, []]
      );

      const { objects, ids } = state;

      return {
        ...state,
        objects: { ...objects, ...newObjects },
        ids: [...ids, ...newIds],
      };
    }
    case REMOVE_UPLOAD: {
      const { id } = action;
      const { ids } = state;
      const objects = { ...state.objects };
      delete objects[id];

      return {
        ...state,
        objects,
        ids: ids.filter((uploadId) => uploadId !== id),
      };
    }
    case INIT_UPLOAD: {
      const { objects } = state;
      const upload = {
        ...objects[action.id],
        siteId: action.siteId,
        comment: action.comment,
        arkitSupported: action.arkitSupported,
        rootFile: action.rootFile,
        copyMappings: action.copyMappings,
        mappingsFromVersion: action.mappingsFromVersion,
        progress: 0,
        status: INITIALIZED,
      };

      return {
        ...state,
        objects: { ...objects, [action.id]: upload },
      };
    }
    case UPLOAD_STARTED: {
      const { objects } = state;
      const { id, versionId } = action;

      const upload = {
        ...objects[id],
        versionId,
        status: UPLOADING,
      };

      return {
        ...state,
        objects: { ...objects, [id]: upload },
      };
    }
    case UPLOAD_PROGRESS: {
      const { objects } = state;
      const { id, progress } = action;

      const upload = {
        ...objects[id],
        progress,
      };

      return {
        ...state,
        objects: { ...objects, [id]: upload },
      };
    }
    case UPLOAD_COMPLETED: {
      const { objects } = state;
      const { id } = action;

      const upload = {
        ...objects[id],
        status: UPLOADED,
      };

      return {
        ...state,
        objects: { ...objects, [id]: upload },
      };
    }
    case UPLOAD_FAILED: {
      const { objects } = state;
      const { id } = action;

      const upload = {
        ...objects[id],
        status: FAILED,
      };

      return {
        ...state,
        objects: { ...objects, [id]: upload },
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
